import {
  Grid,
  Box, Skeleton
} from "@mui/material";
import {
  ScheduleOutlined
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import {CARD_CAPTION_STYLE} from "../../../../constants/Styles";
import {ContainedButton} from "../../../common/StyledButtons";
import {withRouter} from "react-router";
import {getSiteHoursReportByIdAndTime} from "../../../../selectors/SiteSelectors";
import {observer} from "mobx-react-lite";
import {getSiteHoursReport} from "../../../../actions/internal/SiteActions";
import {getMonthName} from "../../../../utilities/DateUtilities";
import StyledSection from "../../../common/StyledSection";
import { trackButtonClick } from "../../../../utilities/AnalyticsUtilities";

const ConsultingCard = ({ history, siteId }) => {
  const [ isLoading, setIsLoading ] = useState(true);

  const hoursReport = getSiteHoursReportByIdAndTime(siteId, 0)

  useEffect(() => {
    loadData().then();
  }, [siteId])

  const loadData = async () => {
    try {
      await getSiteHoursReport(siteId, 0)
    } catch (ex) {
      console.error(ex);
    } finally {
      setIsLoading(false);
    }
  }

  const renderLoadingContent = () => (
    <>
      <Skeleton variant="rectangular" width={85} height={36} sx={{ marginBottom: '5px' }} />
      <Skeleton variant="rectangular" width={210} height={20} />
    </>
  )

  const getCurrentTotalHours = () => {
    if (hoursReport
      && hoursReport.time_utilized
      && hoursReport.time_utilized.total_time_hours) return hoursReport.time_utilized.total_time_hours;
    return '0';
  }
    

  const getCurrentTotalHoursMessage = () => {
    if (renderLoadingContent() === undefined) return 'Not currently available.'
    return `used this cycle.`
  }

  const handleExploreSupport = () => {
    trackButtonClick('Explore Support', 'Dashboard');
    history.push(`/dashboard/site/${siteId}/support`)
  }

  return (
    <StyledSection
      title="Support"
      >
      {isLoading ? renderLoadingContent() :
        <Box>
          <h4 style={{ margin: 0 }}>{getCurrentTotalHours() === undefined ? '--' : getCurrentTotalHours()} hours</h4>
          <p style={{ margin: 0 }}>{getCurrentTotalHoursMessage()}</p>
        </Box>
        }
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop: '32px', position: 'relative', zIndex: 15}}>
          <ContainedButton
            sx={{ padding: '8px 16px 8px 16px' }}
            onClick={handleExploreSupport}
          >Explore Support</ContainedButton>
        </Box>
      </StyledSection>
  )
}

export default observer(withRouter(ConsultingCard));
